import {useState, useEffect} from 'react'
import { Link } from 'react-router-dom'

import styles from "./SidebarCard.module.css"

import {GiHamburgerMenu} from "react-icons/gi"

import BackgroundOptions from './BackgroundOptions/BackgroundOptions'
import ShadowOptions from './ShadowOptions/ShadowOptions'

export default function SidebarCard(props) {
  // const [sidebarWidth, setSidebarWidth] = useState(300);
  // const [minimisedSidebar, setMinimisedSidebar] = useState(false);

  // useEffect(() => {
  //   document.getElementsByTagName("body")[0].addEventListener("click", () => {
  //     setBgSelected(false);
  //   })
  
  //   return () => {
  //     second;
  //   };
  // }, [bgSelected]);

  const minimiseSidebar = () => {
    props.setSidebarWidth(!props.minimisedSidebar ? 0 : 300);
  }

  // style={{width: `${props.sidebarWidth}px`, padding: `${props.sidebarWidth === 300 ? "0 25px" : "0"}`}}

  return (
    <div className={styles.sidebarContainer}>
      <aside className={styles.sidebar}>
        <header className={styles.header} style={{marginLeft: `${props.sidebarWidth !== 300 ? "25px" : "0"}`}}>
          {/* <button className={styles.hamburgerMenu} onClick={() => {minimiseSidebar(); props.setMinimisedSidebar(!props.minimisedSidebar)}}><GiHamburgerMenu /></button> */}
          <Link to="/" className={styles.logo}>Wide<span className={styles.highlighted}>Sketch</span></Link>
        </header>
        {props.children}
      </aside>
    </div>
  )
}
